import { getAnalyticsPlugin } from '@/app/(main)/_components/logger/analytics/get-analytics-plugin';

export function identifyAnalyticsUser(userId: string | undefined): void {
  if (!userId) {
    return;
  }

  getAnalyticsPlugin().identify(userId);
}

export function resetAnalyticsIdentity(): void {
  getAnalyticsPlugin().reset();
}
